import type {
  AnalyticsEventDefinition,
  AnalyticsEventName,
  AnalyticsPropertyDefinition,
} from "./types";

export const ANALYTICS_EVENTS = {
  USER_LOGGED_IN: "User Logged In",
  USER_LOGGED_OUT: "User Logged Out",
  USER_REGISTERED: "User Registered",

  PROJECT_CREATED: "Project Created",
  PROJECT_OPENED: "Project Opened",
  PROJECT_UPDATED: "Project Updated",
  PROJECT_DELETED: "Project Deleted",
  PROJECT_ARCHIVED: "Project Archived",
  PROJECT_UNARCHIVED: "Project Unarchived",

  DOCUMENTATION_VIEWED: "Documentation Viewed",

  SECTION_CREATED: "Section Created",
  SECTION_VIEWED: "Section Viewed",
  SECTION_DELETED: "Section Deleted",

  IMAGE_UPLOADED: "Image Uploaded",
  PLAN_UPLOADED: "Plan Uploaded",
  PLAN_REMOVED: "Plan Removed",

  PROGRESS_REPORT_VIEWED: "Progress Report Viewed",

  ORGANIZATION_CREATED: "Organization Created",
  ORGANIZATION_UPDATED: "Organization Updated",
  TEAM_MEMBER_INVITED: "Team Member Invited",
  TEAM_MEMBER_REMOVED: "Team Member Removed",
  MEMBER_ROLE_UPDATED: "Member Role Updated",

  PROJECT_TEAM_MEMBER_ADDED: "Project Team Member Added",
  PROJECT_TEAM_MEMBER_ROLE_CHANGED: "Project Team Member Role Changed",
  PROJECT_TEAM_MEMBER_REMOVED: "Project Team Member Removed",

  PROFILE_UPDATED: "Profile Updated",
  PASSWORD_CHANGED: "Password Changed",

  EXCEL_EXPORTED: "Excel Exported",
  GAEB_EXPORTED: "GAEB Exported",

  SMART_SURVEYOR_TAB_CHANGED: "Smart Surveyor Tab Changed",
  SMART_SURVEYOR_PLAN_SELECTED: "Smart Surveyor Plan Selected",
  SMART_SURVEYOR_DIAGRAM_SELECTED: "Smart Surveyor Diagram Selected",
  SMART_SURVEYOR_SIDEBAR_MODE_CHANGED: "Smart Surveyor Sidebar Mode Changed",
  SMART_SURVEYOR_WORK_MODE_CHANGED: "Smart Surveyor Work Mode Changed",

  SMART_SURVEYOR_GROUP_SELECTED: "Smart Surveyor Group Selected",
  SMART_SURVEYOR_GROUP_APPROVAL_TOGGLED:
    "Smart Surveyor Group Approval Toggled",
  SMART_SURVEYOR_GROUPS_BULK_APPROVED: "Smart Surveyor Groups Bulk Approved",
  SMART_SURVEYOR_GROUP_MARKED_REVIEWED: "Smart Surveyor Group Marked Reviewed",
  SMART_SURVEYOR_GROUP_RENAMED: "Smart Surveyor Group Renamed",
  SMART_SURVEYOR_GROUP_DELETED: "Smart Surveyor Group Deleted",
  SMART_SURVEYOR_GROUP_LV_MATCH_SAVED: "Smart Surveyor Group LV Match Saved",
  SMART_SURVEYOR_TRAVERSAL_STARTED: "Smart Surveyor Traversal Started",
  SMART_SURVEYOR_ELEMENT_SELECTED: "Smart Surveyor Element Selected",
  SMART_SURVEYOR_ELEMENTS_CREATED: "Smart Surveyor Elements Created",
  SMART_SURVEYOR_ELEMENT_UPDATED: "Smart Surveyor Element Updated",
  SMART_SURVEYOR_ELEMENT_DELETED: "Smart Surveyor Element Deleted",
  SMART_SURVEYOR_ELEMENTS_BULK_DELETED: "Smart Surveyor Elements Bulk Deleted",
  SMART_SURVEYOR_ELEMENTS_BULK_MOVED: "Smart Surveyor Elements Bulk Moved",
  SMART_SURVEYOR_GRID_REVIEW_OPENED: "Smart Surveyor Grid Review Opened",

  SMART_SURVEYOR_ROUTE_SELECTED: "Smart Surveyor Route Selected",
  SMART_SURVEYOR_ROUTES_CREATED: "Smart Surveyor Routes Created",
  SMART_SURVEYOR_ROUTE_PATH_EDITED: "Smart Surveyor Route Path Edited",
  SMART_SURVEYOR_ROUTE_TYPE_CHANGED: "Smart Surveyor Route Type Changed",
  SMART_SURVEYOR_ROUTE_DELETED: "Smart Surveyor Route Deleted",
  SMART_SURVEYOR_PAGE_SCALE_SET: "Smart Surveyor Page Scale Set",

  SMART_SURVEYOR_LAYOUT_VIEW_CHANGED: "Smart Surveyor Layout View Changed",
  SMART_SURVEYOR_ZONE_SELECTED: "Smart Surveyor Zone Selected",
  SMART_SURVEYOR_ROOM_SELECTED: "Smart Surveyor Room Selected",
  SMART_SURVEYOR_ROOMS_CREATED: "Smart Surveyor Rooms Created",
  SMART_SURVEYOR_ROOMS_MERGED: "Smart Surveyor Rooms Merged",
  SMART_SURVEYOR_ROOM_RENAMED: "Smart Surveyor Room Renamed",
  SMART_SURVEYOR_ROOM_SHAPE_EDITED: "Smart Surveyor Room Shape Edited",
  SMART_SURVEYOR_ROOM_DELETED: "Smart Surveyor Room Deleted",

  SMART_SURVEYOR_PLAN_PDF_EXPORTED: "Smart Surveyor Plan PDF Exported",
  SMART_SURVEYOR_SELECTION_AREA_CREATED:
    "Smart Surveyor Selection Area Created",
  SMART_SURVEYOR_SELECTION_AREA_CHANGED:
    "Smart Surveyor Selection Area Changed",
  SMART_SURVEYOR_SELECTION_AREA_DELETED:
    "Smart Surveyor Selection Area Deleted",

  SMART_SURVEYOR_OVERVIEW_OPENED: "Smart Surveyor Overview Opened",
  SMART_SURVEYOR_CLAUDIA_MESSAGE_SENT: "Smart Surveyor Claudia Message Sent",
  SMART_SURVEYOR_CLAUDIA_TURN_FINISHED: "Smart Surveyor Claudia Turn Finished",
  SMART_SURVEYOR_CLAUDIA_CONFIRMATION_ANSWERED:
    "Smart Surveyor Claudia Confirmation Answered",
  SMART_SURVEYOR_CLAUDIA_THREAD_STARTED:
    "Smart Surveyor Claudia Thread Started",
  SMART_SURVEYOR_OVERVIEW_TYPE_RENAMED: "Smart Surveyor Overview Type Renamed",
  SMART_SURVEYOR_OVERVIEW_LV_MATCH_SET: "Smart Surveyor Overview LV Match Set",
  SMART_SURVEYOR_OVERVIEW_UNIT_SET: "Smart Surveyor Overview Unit Set",
  SMART_SURVEYOR_OVERVIEW_MANUAL_PRICE_SET:
    "Smart Surveyor Overview Manual Price Set",
  SMART_SURVEYOR_OVERVIEW_PRICE_CALCULATED:
    "Smart Surveyor Overview Price Calculated",
  SMART_SURVEYOR_OVERVIEW_PRICES_CALCULATED:
    "Smart Surveyor Overview Prices Calculated",
  SMART_SURVEYOR_OVERVIEW_DUPLICATE_NAMES_APPLIED:
    "Smart Surveyor Overview Duplicate Names Applied",
  SMART_SURVEYOR_OVERVIEW_LV_REMATCH_STARTED:
    "Smart Surveyor Overview LV Rematch Started",
  SMART_SURVEYOR_OVERVIEW_LV_REMATCH_APPLIED:
    "Smart Surveyor Overview LV Rematch Applied",

  SMART_SURVEYOR_HISTORY_OPENED: "Smart Surveyor History Opened",
  SMART_SURVEYOR_HISTORY_REVERTED: "Smart Surveyor History Reverted",
  SMART_SURVEYOR_PLAN_COMPARISON_OPENED:
    "Smart Surveyor Plan Comparison Opened",
  SMART_SURVEYOR_PLAN_MOVED_TO_FOLDER: "Smart Surveyor Plan Moved To Folder",
  SMART_SURVEYOR_PLAN_OPENED_IN_NEW_TAB:
    "Smart Surveyor Plan Opened In New Tab",
  SMART_SURVEYOR_FOLDER_CREATED: "Smart Surveyor Folder Created",
  SMART_SURVEYOR_FOLDER_RENAMED: "Smart Surveyor Folder Renamed",
  SMART_SURVEYOR_FOLDER_DELETED: "Smart Surveyor Folder Deleted",
  SMART_SURVEYOR_FOLDER_SUGGESTION_REQUESTED:
    "Smart Surveyor Folder Suggestion Requested",
  SMART_SURVEYOR_FOLDER_SUGGESTION_APPLIED:
    "Smart Surveyor Folder Suggestion Applied",
  SMART_SURVEYOR_COMPARED_PLAN_SELECTED:
    "Smart Surveyor Compared Plan Selected",
  SMART_SURVEYOR_COMPARISON_TAB_CHANGED:
    "Smart Surveyor Comparison Tab Changed",

  SMART_SURVEYOR_RESEARCH_REPORT_PDF_EXPORTED:
    "Smart Surveyor Research Report PDF Exported",

  SMART_SURVEYOR_KARL_STEP_STARTED: "Smart Surveyor Karl Step Started",
  SMART_SURVEYOR_KARL_WALKTHROUGH_STOPPED:
    "Smart Surveyor Karl Walkthrough Stopped",
  SMART_SURVEYOR_KARL_QUESTION_ANSWERED:
    "Smart Surveyor Karl Question Answered",
  SMART_SURVEYOR_KARL_TOOL_USED: "Smart Surveyor Karl Tool Used",
  SMART_SURVEYOR_KARL_BOARD_CIRCUITS_CONFIRMED:
    "Smart Surveyor Karl Board Circuits Confirmed",
  SMART_SURVEYOR_KARL_DEVICES_REASSIGNED:
    "Smart Surveyor Karl Devices Reassigned",
  SMART_SURVEYOR_CABLE_RUN_EDITED: "Smart Surveyor Cable Run Edited",
  SMART_SURVEYOR_CABLE_RUN_DEVICES_CHANGED:
    "Smart Surveyor Cable Run Devices Changed",
  SMART_SURVEYOR_CABLE_RUN_ADDED: "Smart Surveyor Cable Run Added",
  SMART_SURVEYOR_CABLE_RUN_REROUTED: "Smart Surveyor Cable Run Rerouted",
  SMART_SURVEYOR_CABLE_TAKEOFF_RESET: "Smart Surveyor Cable Takeoff Reset",
  SMART_SURVEYOR_CABLE_FEED_POINT_CHANGED:
    "Smart Surveyor Cable Feed Point Changed",
  SMART_SURVEYOR_CABLE_TRAY_VERDICT_SAVED:
    "Smart Surveyor Cable Tray Verdict Saved",
  SMART_SURVEYOR_CABLE_WALL_SAVED: "Smart Surveyor Cable Wall Saved",
  SMART_SURVEYOR_CABLE_WALL_REMOVED: "Smart Surveyor Cable Wall Removed",
  SMART_SURVEYOR_CABLE_PLAN_RECALCULATED:
    "Smart Surveyor Cable Plan Recalculated",
  SMART_SURVEYOR_KARL_CHAT_MESSAGE_SENT:
    "Smart Surveyor Karl Chat Message Sent",
  SMART_SURVEYOR_KARL_CHAT_ANSWER_RECEIVED:
    "Smart Surveyor Karl Chat Answer Received",
  SMART_SURVEYOR_KARL_CHAT_ANSWER_FAILED:
    "Smart Surveyor Karl Chat Answer Failed",

  SMART_SURVEYOR_ADDITIONAL_UPLOAD_OPENED:
    "Smart Surveyor Additional Upload Opened",
  SMART_SURVEYOR_FILES_SUBMITTED: "Smart Surveyor Files Submitted",
  SMART_SURVEYOR_CREDITS_BLOCKED: "Smart Surveyor Credits Blocked",
  SMART_SURVEYOR_UPLOAD_STARTED: "Smart Surveyor Upload Started",
  SMART_SURVEYOR_UPLOAD_COMPLETED: "Smart Surveyor Upload Completed",
  SMART_SURVEYOR_UPLOAD_FAILED: "Smart Surveyor Upload Failed",
  SMART_SURVEYOR_UPLOAD_RESUMED: "Smart Surveyor Upload Resumed",

  RESEARCH_CHAT_OPENED: "Research Chat Opened",
  RESEARCH_CHAT_MESSAGE_SENT: "Research Chat Message Sent",
  RESEARCH_CHAT_RESPONSE_RECEIVED: "Research Chat Response Received",
  RESEARCH_CHAT_RESPONSE_FAILED: "Research Chat Response Failed",
  RESEARCH_CHAT_FILE_ATTACHED: "Research Chat File Attached",
  RESEARCH_CHAT_CROP_ATTACHED: "Research Chat Crop Attached",

  ONBOARDING_STARTED: "Onboarding Started",
  ONBOARDING_STEP_VIEWED: "Onboarding Step Viewed",
  ONBOARDING_COMPLETED: "Onboarding Completed",
  ONBOARDING_SKIPPED: "Onboarding Skipped",
} as const;

const GROUP_KINDS = [
  "elements",
  "routes",
  "cableTakeoff",
  "quantities",
] as const;

const KARL_STEPS = ["boards", "heights", "trays", "walls"] as const;

const KARL_CHAT_SOURCES = [
  "user",
  "askAbout",
  "runSelected",
  "opening",
  "boardMoved",
] as const;

export const ANALYTICS_CONTEXT_PROPERTY_DEFINITIONS = {
  environment: {
    type: "enum",
    values: ["development", "staging", "production"],
    isRequired: true,
    description: "App environment the event was sent from.",
  },
  organizationId: {
    type: "string",
    isRequired: false,
    description: "Organization of the signed-in user; absent before login.",
  },
  projectId: {
    type: "string",
    isRequired: false,
    description: "Project the event belongs to; absent outside a project.",
  },
} as const satisfies Record<string, AnalyticsPropertyDefinition>;

export const ANALYTICS_EVENT_DEFINITIONS = {
  "User Logged In": {
    description: "User signed in successfully.",
    properties: {
      method: {
        type: "enum",
        values: ["email"],
        isRequired: true,
        description: "Sign-in method.",
      },
    },
  },
  "User Logged Out": {
    description: "User signed out.",
    properties: {},
  },
  "User Registered": {
    description: "New account created.",
    properties: {
      hasInvitation: {
        type: "boolean",
        isRequired: true,
        description: "Registered through an invitation link.",
      },
      organizationName: {
        type: "string",
        isRequired: false,
        description: "Name of the organization created during registration.",
      },
    },
  },

  "Project Created": {
    description: "Project created in the project wizard.",
    properties: {
      projectTitle: {
        type: "string",
        isRequired: true,
        description: "Project title.",
      },
      hasDescription: {
        type: "boolean",
        isRequired: true,
        description: "A description was entered.",
      },
      titleLength: {
        type: "number",
        isRequired: true,
        description: "Number of characters in the title.",
      },
    },
  },
  "Project Opened": {
    description:
      "User clicked a project card on the dashboard to open the project.",
    properties: {
      projectTitle: {
        type: "string",
        isRequired: true,
        description: "Project title.",
      },
    },
  },
  "Project Updated": {
    description: "Project renamed.",
    properties: {
      projectTitle: {
        type: "string",
        isRequired: true,
        description: "New project title.",
      },
    },
  },
  "Project Deleted": {
    description: "Project deleted from the dashboard.",
    properties: {},
  },
  "Project Archived": {
    description:
      "Project archived from the dashboard, after the server confirmed.",
    properties: {},
  },
  "Project Unarchived": {
    description:
      "Project restored from the archive on the dashboard, after the server confirmed.",
    properties: {},
  },

  "Documentation Viewed": {
    description: "Documentation page loaded.",
    properties: {
      documentationId: {
        type: "string",
        isRequired: false,
        description: "Documentation id.",
      },
    },
  },

  "Section Created": {
    description: "Project section created.",
    properties: {
      sectionId: {
        type: "string",
        isRequired: true,
        description: "Section id.",
      },
      sectionName: {
        type: "string",
        isRequired: true,
        description: "Section name.",
      },
    },
  },
  "Section Viewed": {
    description: "Project section opened.",
    properties: {
      sectionId: {
        type: "string",
        isRequired: true,
        description: "Section id.",
      },
      sectionName: {
        type: "string",
        isRequired: true,
        description: "Section name.",
      },
    },
  },
  "Section Deleted": {
    description: "Project section deleted.",
    properties: {
      sectionId: {
        type: "string",
        isRequired: true,
        description: "Section id.",
      },
    },
  },

  "Image Uploaded": {
    description: "Site images uploaded to a project.",
    properties: {
      imageCount: {
        type: "number",
        isRequired: true,
        description: "Number of images uploaded.",
      },
    },
  },
  "Plan Uploaded": {
    description: "Plan file uploaded to a project section.",
    properties: {
      sectionId: {
        type: "string",
        isRequired: true,
        description: "Section id.",
      },
      fileType: {
        type: "string",
        isRequired: false,
        description: "File extension, lowercased.",
      },
    },
  },
  "Plan Removed": {
    description: "Plan removed from a project section.",
    properties: {
      sectionId: {
        type: "string",
        isRequired: true,
        description: "Section id.",
      },
    },
  },

  "Progress Report Viewed": {
    description: "Section progress report loaded.",
    properties: {
      sectionId: {
        type: "string",
        isRequired: false,
        description: "Section id.",
      },
    },
  },

  "Organization Created": {
    description: "Organization created by a global admin.",
    properties: {
      organizationName: {
        type: "string",
        isRequired: true,
        description: "Organization name.",
      },
      type: {
        type: "enum",
        values: ["general", "quantity_surveyor"],
        isRequired: true,
        description: "Organization type; controls feature availability.",
      },
    },
  },
  "Organization Updated": {
    description: "Organization settings saved.",
    properties: {},
  },
  "Team Member Invited": {
    description: "User invited to the organization.",
    properties: {
      role: {
        type: "string",
        isRequired: true,
        description: "Organization role of the invitee.",
      },
    },
  },
  "Team Member Removed": {
    description: "User removed from the organization.",
    properties: {},
  },
  "Member Role Updated": {
    description: "Organization role of a member changed.",
    properties: {
      newRole: {
        type: "string",
        isRequired: true,
        description: "New organization role.",
      },
    },
  },

  "Project Team Member Added": {
    description: "User added to a project team.",
    properties: {
      role: {
        type: "string",
        isRequired: true,
        description: "Project role of the added member.",
      },
    },
  },
  "Project Team Member Role Changed": {
    description: "Project role of a team member changed.",
    properties: {
      newRole: {
        type: "string",
        isRequired: true,
        description: "New project role.",
      },
    },
  },
  "Project Team Member Removed": {
    description: "User removed from a project team.",
    properties: {},
  },

  "Profile Updated": {
    description: "User profile saved.",
    properties: {},
  },
  "Password Changed": {
    description: "User changed their password.",
    properties: {},
  },

  "Excel Exported": {
    description: "Excel file exported.",
    properties: {
      exportVariant: {
        type: "enum",
        values: [
          "fullReport",
          "perPlan",
          "countList",
          "folderCountList",
          "rooms",
        ],
        isRequired: false,
        description:
          "Smart Surveyor export variant; absent for legacy section exports.",
      },
      roomCount: {
        type: "number",
        isRequired: false,
        description: "Rooms on the plan page, for the rooms export.",
      },
      floorGroupCount: {
        type: "number",
        isRequired: false,
        description: "Floor plan element groups in the export.",
      },
      cableGroupCount: {
        type: "number",
        isRequired: false,
        description: "Cable groups in the export.",
      },
      quantityGroupCount: {
        type: "number",
        isRequired: false,
        description: "Quantity items in the export.",
      },
      planCount: {
        type: "number",
        isRequired: false,
        description: "Plans in the export.",
      },
      diagramCount: {
        type: "number",
        isRequired: false,
        description: "Diagrams in the export.",
      },
      positionCount: {
        type: "number",
        isRequired: false,
        description: "Bill of quantities positions in the export.",
      },
      unmatchedRowCount: {
        type: "number",
        isRequired: false,
        description: "Rows not matched to a bill of quantities position.",
      },
      folderCount: {
        type: "number",
        isRequired: false,
        description:
          "Folder columns in the count list by folder, the no-folder column included.",
      },
      sectionId: {
        type: "string",
        isRequired: false,
        description: "Section id, for exports from a legacy project section.",
      },
      printVersion: {
        type: "boolean",
        isRequired: false,
        description: "Legacy section export in print layout.",
      },
    },
  },
  "GAEB Exported": {
    description: "GAEB X83 file exported from Smart Surveyor.",
    properties: {
      planCount: {
        type: "number",
        isRequired: true,
        description: "Plans in the export.",
      },
      positionCount: {
        type: "number",
        isRequired: true,
        description: "GAEB positions in the export.",
      },
    },
  },

  "Smart Surveyor Tab Changed": {
    description: "User clicked a right-panel tab in plans mode.",
    properties: {
      tab: {
        type: "enum",
        values: ["elements", "routes", "cableTakeoff"],
        isRequired: true,
        description: "Tab opened.",
      },
    },
  },
  "Smart Surveyor Plan Selected": {
    description: "User picked a floor plan in the sidebar.",
    properties: {
      floorPlanId: {
        type: "string",
        isRequired: true,
        description: "Floor plan id.",
      },
    },
  },
  "Smart Surveyor Diagram Selected": {
    description: "User picked a distribution board diagram in the sidebar.",
    properties: {
      diagramId: {
        type: "string",
        isRequired: true,
        description: "Diagram id.",
      },
    },
  },
  "Smart Surveyor Sidebar Mode Changed": {
    description: "User switched the sidebar between plans and diagrams.",
    properties: {
      mode: {
        type: "enum",
        values: ["plans", "diagrams"],
        isRequired: true,
        description: "Sidebar mode switched to.",
      },
    },
  },
  "Smart Surveyor Work Mode Changed": {
    description: "User switched between planning and execution.",
    properties: {
      workMode: {
        type: "enum",
        values: ["planning", "execution"],
        isRequired: true,
        description: "Work mode switched to.",
      },
    },
  },
  "Smart Surveyor Group Selected": {
    description: "User clicked a group in a review tab list.",
    properties: {
      groupKind: {
        type: "enum",
        values: GROUP_KINDS,
        isRequired: true,
        description: "Which tab the group belongs to.",
      },
      groupTypeId: {
        type: "string",
        isRequired: true,
        description: "Id of the group's type (element type, route type, ...).",
      },
      elementCount: {
        type: "number",
        isRequired: true,
        description: "Items in the group on this plan.",
      },
    },
  },
  "Smart Surveyor Group Approval Toggled": {
    description: "Group approved or unapproved, after the server confirmed.",
    properties: {
      groupKind: {
        type: "enum",
        values: GROUP_KINDS,
        isRequired: true,
        description: "Which tab the group belongs to.",
      },
      groupTypeId: {
        type: "string",
        isRequired: true,
        description: "Id of the group's type (element type, route type, ...).",
      },
      approved: {
        type: "boolean",
        isRequired: true,
        description: "True when approved, false when unapproved.",
      },
    },
  },
  "Smart Surveyor Groups Bulk Approved": {
    description:
      "Approve-all or unapprove-all confirmed, after the server confirmed.",
    properties: {
      groupKind: {
        type: "enum",
        values: GROUP_KINDS,
        isRequired: true,
        description: "Which tab the groups belong to.",
      },
      groupCount: {
        type: "number",
        isRequired: true,
        description: "Groups changed.",
      },
      approved: {
        type: "boolean",
        isRequired: true,
        description: "True when approved, false when unapproved.",
      },
    },
  },
  "Smart Surveyor Group Marked Reviewed": {
    description: "User resolved a group's needs-review flag.",
    properties: {
      groupKind: {
        type: "enum",
        values: GROUP_KINDS,
        isRequired: true,
        description: "Which tab the group belongs to.",
      },
      groupTypeId: {
        type: "string",
        isRequired: true,
        description: "Id of the group's type (element type, route type, ...).",
      },
    },
  },
  "Smart Surveyor Group Renamed": {
    description: "Group renamed, after the server confirmed.",
    properties: {
      groupKind: {
        type: "enum",
        values: GROUP_KINDS,
        isRequired: true,
        description: "Which tab the group belongs to.",
      },
      scope: {
        type: "enum",
        values: ["project", "plan"],
        isRequired: true,
        description: "Renamed on all plans of the project, or this plan only.",
      },
    },
  },
  "Smart Surveyor Group Deleted": {
    description: "Whole group deleted, after the server confirmed.",
    properties: {
      groupKind: {
        type: "enum",
        values: GROUP_KINDS,
        isRequired: true,
        description: "Which tab the group belongs to.",
      },
      groupTypeId: {
        type: "string",
        isRequired: true,
        description: "Id of the group's type (element type, route type, ...).",
      },
      elementCount: {
        type: "number",
        isRequired: true,
        description: "Items the group had on this plan.",
      },
      deviceHandling: {
        type: "enum",
        values: ["none", "movedToRun", "restored"],
        isRequired: false,
        description:
          "Cable takeoff only: what happened to the run's devices (none had any, moved to another run, put back).",
      },
    },
  },
  "Smart Surveyor Group LV Match Saved": {
    description: "LV position assigned to a group, after the server confirmed.",
    properties: {
      groupKind: {
        type: "enum",
        values: GROUP_KINDS,
        isRequired: true,
        description: "Which tab the group belongs to.",
      },
      groupTypeId: {
        type: "string",
        isRequired: true,
        description: "Id of the group's type (element type, route type, ...).",
      },
    },
  },
  "Smart Surveyor Traversal Started": {
    description: "User started the step-by-step review with the Start button.",
    properties: {
      groupKind: {
        type: "enum",
        values: GROUP_KINDS,
        isRequired: true,
        description: "Which tab the traversal runs in.",
      },
    },
  },
  "Smart Surveyor Element Selected": {
    description:
      "User clicked a floor plan element in the list or on the plan.",
    properties: {
      elementTypeId: {
        type: "string",
        isRequired: true,
        description: "Element type id of the element's group.",
      },
    },
  },
  "Smart Surveyor Elements Created": {
    description: "Elements added in creation mode, after the server confirmed.",
    properties: {
      elementCount: {
        type: "number",
        isRequired: true,
        description: "Elements created.",
      },
      isMultiAdd: {
        type: "boolean",
        isRequired: true,
        description: "Created with multi-add mode on.",
      },
    },
  },
  "Smart Surveyor Element Updated": {
    description: "Element saved in the inspector, after the server confirmed.",
    properties: {
      groupChanged: {
        type: "boolean",
        isRequired: true,
        description: "Element moved to another group.",
      },
      markerChanged: {
        type: "boolean",
        isRequired: true,
        description: "Group, position, size or multiplier changed.",
      },
      noteChanged: {
        type: "boolean",
        isRequired: true,
        description: "Element note changed.",
      },
    },
  },
  "Smart Surveyor Element Deleted": {
    description: "Single element deleted, after the server confirmed.",
    properties: {
      elementTypeId: {
        type: "string",
        isRequired: true,
        description: "Element type id of the element's group.",
      },
    },
  },
  "Smart Surveyor Elements Bulk Deleted": {
    description: "Elements deleted together in grid review.",
    properties: {
      elementCount: {
        type: "number",
        isRequired: true,
        description: "Elements deleted.",
      },
    },
  },
  "Smart Surveyor Elements Bulk Moved": {
    description: "Elements moved to another group together in grid review.",
    properties: {
      elementCount: {
        type: "number",
        isRequired: true,
        description: "Elements moved.",
      },
    },
  },
  "Smart Surveyor Grid Review Opened": {
    description: "User opened grid review.",
    properties: {},
  },

  "Smart Surveyor Route Selected": {
    description:
      "User clicked a route in the list, the inspector arrows or on the plan.",
    properties: {
      routeTypeId: {
        type: "string",
        isRequired: true,
        description: "Route type id of the route's group.",
      },
    },
  },
  "Smart Surveyor Routes Created": {
    description: "Routes added in creation mode, after the server confirmed.",
    properties: {
      routeCount: {
        type: "number",
        isRequired: true,
        description: "Routes created.",
      },
      newGroupCount: {
        type: "number",
        isRequired: true,
        description: "Route types the plan did not have before the save.",
      },
    },
  },
  "Smart Surveyor Route Path Edited": {
    description: "Route path saved after editing, after the server confirmed.",
    properties: {
      metresBefore: {
        type: "number",
        isRequired: true,
        description: "Route metres before the edit.",
      },
      metresAfter: {
        type: "number",
        isRequired: true,
        description: "Route metres after the edit.",
      },
    },
  },
  "Smart Surveyor Route Type Changed": {
    description:
      "Route moved to another route type, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Route Deleted": {
    description: "Single route deleted, after the server confirmed.",
    properties: {
      routeTypeId: {
        type: "string",
        isRequired: true,
        description: "Route type id of the route's group.",
      },
    },
  },
  "Smart Surveyor Page Scale Set": {
    description: "Plan page scale saved, after the server confirmed.",
    properties: {
      method: {
        type: "enum",
        values: ["calibrated", "resetToDetected"],
        isRequired: true,
        description:
          "Measured by the user, or reset to the automatically detected scale.",
      },
    },
  },

  "Smart Surveyor Layout View Changed": {
    description:
      "User switched the zones / rooms / walls tabs in execution mode.",
    properties: {
      view: {
        type: "enum",
        values: ["zones", "rooms", "walls"],
        isRequired: true,
        description: "View opened.",
      },
    },
  },
  "Smart Surveyor Zone Selected": {
    description: "User clicked a zone in the list or on the plan.",
    properties: {
      roomCount: {
        type: "number",
        isRequired: true,
        description: "Rooms in the zone.",
      },
    },
  },
  "Smart Surveyor Room Selected": {
    description: "User opened a room from the list or on the plan.",
    properties: {},
  },
  "Smart Surveyor Rooms Created": {
    description:
      "Drawn rooms saved in creation mode, after the server confirmed.",
    properties: {
      roomCount: {
        type: "number",
        isRequired: true,
        description: "Rooms created.",
      },
    },
  },
  "Smart Surveyor Rooms Merged": {
    description:
      "Rooms merged into one from the rooms list, after the server confirmed.",
    properties: {
      roomCount: {
        type: "number",
        isRequired: true,
        description: "Rooms merged into the one.",
      },
    },
  },
  "Smart Surveyor Room Renamed": {
    description: "Room renamed in the inspector, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Room Shape Edited": {
    description:
      "Room's moved points saved in the inspector, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Room Deleted": {
    description: "Room deleted, after the server confirmed.",
    properties: {},
  },

  "Smart Surveyor Plan PDF Exported": {
    description: "Plan PDF from the export dialog generated.",
    properties: {
      content: {
        type: "enum",
        values: ["elements", "routes"],
        isRequired: true,
        description: "What the PDF shows.",
      },
      groupCount: {
        type: "number",
        isRequired: true,
        description: "Groups ticked in the export dialog.",
      },
      hasRooms: {
        type: "boolean",
        isRequired: true,
        description: "PDF includes the rooms pages.",
      },
    },
  },
  "Smart Surveyor Selection Area Created": {
    description: "Selection area saved, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Selection Area Changed": {
    description: "Selection area changed, after the server confirmed.",
    properties: {
      change: {
        type: "enum",
        values: ["shape", "mode", "appliesToElements", "appliesToRoutes"],
        isRequired: true,
        description:
          "What changed: points, include/exclude, or what it applies to.",
      },
    },
  },
  "Smart Surveyor Selection Area Deleted": {
    description: "Selection area deleted, after the server confirmed.",
    properties: {},
  },

  "Smart Surveyor Overview Opened": {
    description: "User opened the overview window.",
    properties: {},
  },
  "Smart Surveyor Claudia Message Sent": {
    description: "User sent a message to Claudia; the text is not sent.",
    properties: {},
  },
  "Smart Surveyor Claudia Turn Finished": {
    description:
      "One Claudia answer ended; sent once per request, never per streamed piece.",
    properties: {
      trigger: {
        type: "enum",
        values: ["message", "confirmation"],
        isRequired: true,
        description:
          "A user message, or the user's answers to Claudia's action cards.",
      },
      outcome: {
        type: "enum",
        values: ["completed", "awaitingConfirmation", "failed", "cancelled"],
        isRequired: true,
        description:
          "Finished, paused for the user to accept/decline, failed, or window closed mid-answer.",
      },
      renameCount: {
        type: "number",
        isRequired: true,
        description: "Renames Claudia made in this answer.",
      },
      lvMatchCount: {
        type: "number",
        isRequired: true,
        description: "LV assignments Claudia made in this answer.",
      },
      settingCount: {
        type: "number",
        isRequired: true,
        description: "Unit or price settings Claudia changed in this answer.",
      },
      priceRunCount: {
        type: "number",
        isRequired: true,
        description: "Project-wide price calculations Claudia ran.",
      },
    },
  },
  "Smart Surveyor Claudia Confirmation Answered": {
    description: "User accepted or declined an action Claudia proposed.",
    properties: {
      decision: {
        type: "enum",
        values: ["accept", "decline"],
        isRequired: true,
        description: "The user's answer.",
      },
    },
  },
  "Smart Surveyor Claudia Thread Started": {
    description: "User clicked new chat in Claudia.",
    properties: {},
  },
  "Smart Surveyor Overview Type Renamed": {
    description:
      "Type renamed in the overview grid, after the server confirmed.",
    properties: {
      kind: {
        type: "enum",
        values: ["element", "route"],
        isRequired: true,
        description: "Element type or route type.",
      },
      scope: {
        type: "enum",
        values: ["project", "plan"],
        isRequired: true,
        description: "Renamed on all plans of the project, or this plan only.",
      },
    },
  },
  "Smart Surveyor Overview LV Match Set": {
    description:
      "LV position assigned in the overview grid, after the server confirmed.",
    properties: {
      typeCount: {
        type: "number",
        isRequired: true,
        description: "Types the server wrote the position to.",
      },
    },
  },
  "Smart Surveyor Overview Unit Set": {
    description:
      "Unit changed in the overview grid, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Overview Manual Price Set": {
    description:
      "Price typed in the overview grid, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Overview Price Calculated": {
    description:
      "AI price calculated for one overview row, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Overview Prices Calculated": {
    description:
      "AI prices calculated from the overview menu, after the server confirmed.",
    properties: {
      mode: {
        type: "enum",
        values: ["missing", "all"],
        isRequired: true,
        description: "Only rows without a price, or all rows.",
      },
      suggestedCount: {
        type: "number",
        isRequired: true,
        description: "Rows that got a price.",
      },
      skippedCount: {
        type: "number",
        isRequired: true,
        description: "Rows skipped.",
      },
      failedCount: {
        type: "number",
        isRequired: true,
        description: "Groups the calculation failed for.",
      },
    },
  },
  "Smart Surveyor Overview Duplicate Names Applied": {
    description: "Duplicate names dialog applied, after the server confirmed.",
    properties: {
      renameCount: {
        type: "number",
        isRequired: true,
        description: "Renames the server applied.",
      },
    },
  },
  "Smart Surveyor Overview LV Rematch Started": {
    description:
      "User opened the automatic LV re-match, which starts its search.",
    properties: {},
  },
  "Smart Surveyor Overview LV Rematch Applied": {
    description:
      "Selected LV re-match proposals saved, after the server confirmed.",
    properties: {
      changeCount: {
        type: "number",
        isRequired: true,
        description: "Assignments the server applied.",
      },
    },
  },

  "Smart Surveyor History Opened": {
    description: "User opened the history drawer.",
    properties: {},
  },
  "Smart Surveyor History Reverted": {
    description:
      "Undo or redo (button, shortcut or history drawer), after the server confirmed.",
    properties: {
      direction: {
        type: "enum",
        values: ["undo", "redo"],
        isRequired: true,
        description: "Undo or redo.",
      },
      planCount: {
        type: "number",
        isRequired: true,
        description: "Plans the reverted change reached.",
      },
    },
  },
  "Smart Surveyor Plan Comparison Opened": {
    description: "User opened the comparison for a plan from the sidebar.",
    properties: {},
  },
  "Smart Surveyor Plan Opened In New Tab": {
    description:
      "User opened a floor plan in a new browser tab from the sidebar. The browser's own right-click menu is not tracked.",
    properties: {
      floorPlanId: {
        type: "string",
        isRequired: true,
        description: "Floor plan id.",
      },
      trigger: {
        type: "enum",
        values: ["menu", "link"],
        isRequired: true,
        description:
          "menu = the row's ⋮ menu item; link = Cmd/Ctrl/Shift-click or middle-click on the row.",
      },
    },
  },
  "Smart Surveyor Plan Moved To Folder": {
    description:
      "Plan moved into a folder or back to the root, after the server confirmed.",
    properties: {
      destination: {
        type: "enum",
        values: ["folder", "root"],
        isRequired: true,
        description: "Where the plan went.",
      },
    },
  },
  "Smart Surveyor Folder Created": {
    description: "Plan folder created, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Folder Renamed": {
    description: "Plan folder renamed, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Folder Deleted": {
    description: "Plan folder deleted, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Folder Suggestion Requested": {
    description:
      "Folder suggestion asked for: on opening without a result, Suggest again or Retry.",
    properties: {},
  },
  "Smart Surveyor Folder Suggestion Applied": {
    description: "Suggested folders applied, after the server confirmed.",
    properties: {
      structure: {
        type: "enum",
        values: ["level", "building", "buildingAndLevel", "trade"],
        isRequired: true,
        description: "How the plans were grouped into folders.",
      },
      folderCount: {
        type: "number",
        isRequired: true,
        description: "Folders created or reused.",
      },
      plansMoved: {
        type: "number",
        isRequired: true,
        description: "Plans moved into a folder.",
      },
      overwrite: {
        type: "boolean",
        isRequired: true,
        description: "Whether plans already in another folder were moved too.",
      },
    },
  },
  "Smart Surveyor Compared Plan Selected": {
    description:
      "User picked the plan to compare against, after the server saved it.",
    properties: {},
  },
  "Smart Surveyor Comparison Tab Changed": {
    description: "User switched tabs in the plan comparison.",
    properties: {
      tab: {
        type: "enum",
        values: ["quantities", "visual"],
        isRequired: true,
        description: "Tab opened.",
      },
    },
  },

  "Smart Surveyor Research Report PDF Exported": {
    description: "Research report PDF generated and downloaded.",
    properties: {},
  },

  "Smart Surveyor Karl Step Started": {
    description: "User clicked Yes on a Karl walkthrough step (cable takeoff).",
    properties: {
      step: {
        type: "enum",
        values: KARL_STEPS,
        isRequired: true,
        description: "Walkthrough step.",
      },
    },
  },
  "Smart Surveyor Karl Walkthrough Stopped": {
    description: "User clicked Stop in the Karl walkthrough (cable takeoff).",
    properties: {
      step: {
        type: "enum",
        values: KARL_STEPS,
        isRequired: true,
        description: "Walkthrough step it was stopped at.",
      },
    },
  },
  "Smart Surveyor Karl Question Answered": {
    description:
      'User answered a Karl question; Later counts as answer "later".',
    properties: {
      askKind: {
        type: "string",
        isRequired: true,
        description:
          "Question kind: place, guess, role, absent, zone, complete.",
      },
      answerId: {
        type: "string",
        isRequired: true,
        description: "Answer chosen, e.g. right, move, later.",
      },
      outcome: {
        type: "enum",
        values: ["accepted", "declined", "committed"],
        isRequired: true,
        description:
          "accepted, declined (incl. later) or committed (waits for a plan click).",
      },
      position: {
        type: "number",
        isRequired: true,
        description: "1-based place of the question in the queue.",
      },
      total: {
        type: "number",
        isRequired: true,
        description: "Questions in the queue.",
      },
      isRevisit: {
        type: "boolean",
        isRequired: true,
        description: "User went back to a question answered before.",
      },
    },
  },
  "Smart Surveyor Karl Tool Used": {
    description:
      "User used a tool on a Karl question (rename, not a board, add board).",
    properties: {
      toolId: {
        type: "string",
        isRequired: true,
        description: "Tool used.",
      },
    },
  },
  "Smart Surveyor Karl Board Circuits Confirmed": {
    description: "User confirmed one board's circuits in the Karl walkthrough.",
    properties: {
      position: {
        type: "number",
        isRequired: true,
        description: "1-based place of the board in the walkthrough.",
      },
      total: {
        type: "number",
        isRequired: true,
        description: "Boards in the walkthrough.",
      },
      isLast: {
        type: "boolean",
        isRequired: true,
        description: "Last board, i.e. the walkthrough is finished.",
      },
      isMainBoard: {
        type: "boolean",
        isRequired: true,
        description: "The board is the main board.",
      },
      suspectCount: {
        type: "number",
        isRequired: true,
        description: "Devices Karl flagged as suspect on this board.",
      },
    },
  },
  "Smart Surveyor Karl Devices Reassigned": {
    description:
      "User moved picked devices to another circuit in the Karl walkthrough.",
    properties: {
      deviceCount: {
        type: "number",
        isRequired: true,
        description: "Devices moved.",
      },
    },
  },
  "Smart Surveyor Cable Run Edited": {
    description: "User changed a property of a cable run.",
    properties: {
      field: {
        type: "enum",
        values: ["feedPoint", "cableType", "resetLength"],
        isRequired: true,
        description: "What was changed.",
      },
    },
  },
  "Smart Surveyor Cable Run Devices Changed": {
    description:
      "Devices removed from, moved between, restored to or adopted onto cable runs.",
    properties: {
      action: {
        type: "enum",
        values: ["removed", "moved", "restored", "adopted"],
        isRequired: true,
        description: "What happened to the devices.",
      },
      deviceCount: {
        type: "number",
        isRequired: true,
        description: "Devices affected.",
      },
    },
  },
  "Smart Surveyor Cable Run Added": {
    description: "User created a new cable run.",
    properties: {
      fromSchematic: {
        type: "boolean",
        isRequired: true,
        description: "Created from a row of the circuit schedule.",
      },
      system: {
        type: "string",
        isRequired: false,
        description: "Cable system of the run's board, when it has one.",
      },
    },
  },
  "Smart Surveyor Cable Run Rerouted": {
    description: "A cable run was rerouted, after the server confirmed.",
    properties: {
      metresBefore: {
        type: "number",
        isRequired: true,
        description: "Billed metres before the reroute.",
      },
      metresAfter: {
        type: "number",
        isRequired: true,
        description: "Billed metres after the reroute.",
      },
    },
  },
  "Smart Surveyor Cable Takeoff Reset": {
    description: "User reset all cable takeoff edits.",
    properties: {},
  },
  "Smart Surveyor Cable Feed Point Changed": {
    description:
      "A feed point (board) or its zone changed from the panel or the plan toolbar.",
    properties: {
      action: {
        type: "enum",
        values: [
          "added",
          "renamed",
          "removed",
          "restored",
          "moved",
          "zoneDrawn",
          "zonesRemoved",
        ],
        isRequired: true,
        description: "What was done to the feed point.",
      },
    },
  },
  "Smart Surveyor Cable Tray Verdict Saved": {
    description:
      "Tray type marked as carrying cable or not, after the server confirmed.",
    properties: {
      carriesCable: {
        type: "enum",
        values: ["yes", "no", "default"],
        isRequired: true,
        description: "Verdict saved; default means reset to the automatic one.",
      },
    },
  },
  "Smart Surveyor Cable Wall Saved": {
    description: "Wall or opening drawn and saved, after the server confirmed.",
    properties: {
      wallKind: {
        type: "string",
        isRequired: true,
        description: "Wall or opening.",
      },
      pointCount: {
        type: "number",
        isRequired: true,
        description: "Points drawn.",
      },
    },
  },
  "Smart Surveyor Cable Wall Removed": {
    description: "Wall or opening removed, after the server confirmed.",
    properties: {},
  },
  "Smart Surveyor Cable Plan Recalculated": {
    description:
      "All cable runs of the plan recalculated, after the server confirmed.",
    properties: {
      wasStale: {
        type: "boolean",
        isRequired: true,
        description: "Inputs had changed since the last calculation.",
      },
      runsRecalculated: {
        type: "number",
        isRequired: true,
        description: "Runs the router returned a route for, changed or not.",
      },
      metresDelta: {
        type: "number",
        isRequired: true,
        description: "Total change in billed metres.",
      },
    },
  },
  "Smart Surveyor Karl Chat Message Sent": {
    description: "User sent a message to Karl in the chat.",
    properties: {},
  },
  "Smart Surveyor Karl Chat Answer Received": {
    description: "Karl's chat answer arrived.",
    properties: {
      source: {
        type: "enum",
        values: KARL_CHAT_SOURCES,
        isRequired: true,
        description: "What sent the question to Karl.",
      },
      suggestionCount: {
        type: "number",
        isRequired: true,
        description: "Suggestions in the answer.",
      },
    },
  },
  "Smart Surveyor Karl Chat Answer Failed": {
    description: "Karl's chat answer failed.",
    properties: {
      source: {
        type: "enum",
        values: KARL_CHAT_SOURCES,
        isRequired: true,
        description: "What sent the question to Karl.",
      },
    },
  },

  "Smart Surveyor Additional Upload Opened": {
    description: "User opened the upload-more-files modal on the review page.",
    properties: {},
  },
  "Smart Surveyor Files Submitted": {
    description: "User clicked Analyze with the selected files.",
    properties: {
      uploadKind: {
        type: "enum",
        values: ["initial", "additional"],
        isRequired: true,
        description: "First upload of the project, or more files later.",
      },
      floorPlanCount: {
        type: "number",
        isRequired: true,
        description: "Floor plan files selected.",
      },
      diagramCount: {
        type: "number",
        isRequired: true,
        description: "Electrical diagram files selected.",
      },
      boqCount: {
        type: "number",
        isRequired: true,
        description: "Bill of quantities files selected.",
      },
      otherCount: {
        type: "number",
        isRequired: true,
        description: "Other files selected.",
      },
    },
  },
  "Smart Surveyor Credits Blocked": {
    description: "The credit check stopped a Smart Surveyor upload.",
    properties: {
      uploadKind: {
        type: "enum",
        values: ["initial", "additional"],
        isRequired: true,
        description: "First upload of the project, or more files later.",
      },
      reason: {
        type: "enum",
        values: ["noCredits", "notEnoughCredits", "checkFailed"],
        isRequired: true,
        description: "Why the upload was blocked.",
      },
      pdfFileCount: {
        type: "number",
        isRequired: true,
        description: "PDF files the upload would have charged for.",
      },
    },
  },
  "Smart Surveyor Upload Started": {
    description: "Smart Surveyor file upload started.",
    properties: {
      uploadKind: {
        type: "enum",
        values: ["initial", "additional"],
        isRequired: true,
        description: "First upload of the project, or more files later.",
      },
      fileCount: {
        type: "number",
        isRequired: true,
        description: "Files being uploaded.",
      },
      totalSizeMb: {
        type: "number",
        isRequired: true,
        description: "Total size of the files in megabytes.",
      },
    },
  },
  "Smart Surveyor Upload Completed": {
    description: "All files of a Smart Surveyor upload finished uploading.",
    properties: {
      uploadKind: {
        type: "enum",
        values: ["initial", "additional"],
        isRequired: true,
        description: "First upload of the project, or more files later.",
      },
      fileCount: {
        type: "number",
        isRequired: true,
        description: "Files uploaded.",
      },
      totalSizeMb: {
        type: "number",
        isRequired: true,
        description: "Total size of the files in megabytes.",
      },
      durationSeconds: {
        type: "number",
        isRequired: true,
        description: "Seconds from upload start to completion.",
      },
    },
  },
  "Smart Surveyor Upload Failed": {
    description: "Smart Surveyor upload broke off.",
    properties: {
      uploadKind: {
        type: "enum",
        values: ["initial", "additional"],
        isRequired: true,
        description: "First upload of the project, or more files later.",
      },
      fileCount: {
        type: "number",
        isRequired: true,
        description: "Files in the upload.",
      },
      error: {
        type: "string",
        isRequired: true,
        description: "Technical error message.",
      },
    },
  },
  "Smart Surveyor Upload Resumed": {
    description: "Interrupted Smart Surveyor file upload resumed.",
    properties: {
      uploadKind: {
        type: "enum",
        values: ["initial", "additional"],
        isRequired: true,
        description: "First upload of the project, or more files later.",
      },
      fileName: {
        type: "string",
        isRequired: true,
        description: "Name of the resumed file.",
      },
    },
  },

  "Research Chat Opened": {
    description:
      "User clicked Project Chat on the research report page; direct visits to the chat URL are only in Page Viewed.",
    properties: {},
  },
  "Research Chat Message Sent": {
    description: "User sent a research chat message.",
    properties: {
      attachmentCount: {
        type: "number",
        isRequired: true,
        description: "Attached document pages.",
      },
      cropCount: {
        type: "number",
        isRequired: true,
        description: "Attached image crops.",
      },
      conversationLength: {
        type: "number",
        isRequired: true,
        description: "Messages in the conversation before this one.",
      },
    },
  },
  "Research Chat Response Received": {
    description: "Research chat answer received.",
    properties: {},
  },
  "Research Chat Response Failed": {
    description: "Research chat answer failed.",
    properties: {
      error: {
        type: "string",
        isRequired: true,
        description: "Error message.",
      },
    },
  },
  "Research Chat File Attached": {
    description: "Document pages attached to a research chat message.",
    properties: {
      filename: {
        type: "string",
        isRequired: true,
        description: "Attached file name.",
      },
      pageCount: {
        type: "number",
        isRequired: true,
        description: "Pages attached.",
      },
    },
  },
  "Research Chat Crop Attached": {
    description: "Image crop attached to a research chat message.",
    properties: {
      filename: {
        type: "string",
        isRequired: true,
        description: "File the crop was taken from.",
      },
      page: {
        type: "number",
        isRequired: true,
        description: "Page the crop was taken from.",
      },
    },
  },

  "Onboarding Started": {
    description: "Smart Surveyor onboarding tour started.",
    properties: {
      source: {
        type: "enum",
        values: ["auto", "help-button"],
        isRequired: true,
        description: "How the tour was started.",
      },
    },
  },
  "Onboarding Step Viewed": {
    description: "Onboarding tour step shown.",
    properties: {
      stepIndex: {
        type: "number",
        isRequired: true,
        description: "Zero-based step index.",
      },
      stepId: {
        type: "string",
        isRequired: true,
        description: "Step id.",
      },
    },
  },
  "Onboarding Completed": {
    description: "Onboarding tour finished.",
    properties: {
      totalSteps: {
        type: "number",
        isRequired: true,
        description: "Steps in the tour.",
      },
    },
  },
  "Onboarding Skipped": {
    description: "Onboarding tour closed before the end.",
    properties: {
      stepIndex: {
        type: "number",
        isRequired: true,
        description: "Step the tour was closed on.",
      },
    },
  },
} as const satisfies Record<AnalyticsEventName, AnalyticsEventDefinition>;
